module.exports = __webpack_public_path__ + "img/Impact characterisation - Ecosystem Services.bd6a43a7.svg";